<div id="openExtendsVideoTourism" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Seleccionar videos para el paquete</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="form-group col-12">
                <input type="text" class="form-control" placeholder="Escribe para buscar por título">
              </div>
              <ng-container *ngIf="videos.length > 0">
                <div class="col-lg-12" style="height: 500px; overflow-y: auto;">
                  <div class="card" *ngFor="let item of videos; let index_ = index"> 
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-12">
                        <span style="position: absolute;
                            top: 0px;
                            left: 10px;
                            right: 10px;
                            background: #fff;
                            bottom: -25px;
                            opacity: .5;" *ngIf="item.checked"></span>
                          <ng-container *ngIf="item.is_generate_iframe">
                            <div class="content-iframe" [innerHTML]="item.iframe_video | safe"> </div>
                          </ng-container>
                          <ng-container *ngIf="!item.is_generate_iframe">
                            <span style="color: rgb(158, 155, 155);">Asegúrese de ingresar un iframe correcto</span>
                          </ng-container>                         
                        </div>
                      </div>
                    </div>
                    <p class="m-t-15 m-b-10 p-l-20"><span class="bold">Titulo video:</span> {{item.title}}
                        <label class="pointer m-t-5 m-b-0">
                            <input type="checkbox" [(ngModel)]="item.checked" (change)="changeChecked()"> <span class="m-l-5">Seleccionar</span>
                        </label>
                    </p>                
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-lg-12 m-t-15 text-right">
            <button class="btn btn-dark" (click)="addSelecteds()">Agregar Seleccionados ({{arr_checkeds.length}})</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
